// ======================================================================
// File Name       : scoringReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const OPEN_REPORT_DIALOG = 'OPEN_REPORT_DIALOG';
export const GET_DETAIL_DRILL = 'GET_DETAIL_DRILL';
export const REPORT_LIST_INIT_SEARCH_INFO = 'REPORT_LIST_INIT_SEARCH_INFO';
export const REPORT_LIST_GET_GROUP_LIST = 'REPORT_LIST_GET_GROUP_LIST';
export const REPORT_LIST_OPEN_GROUP_DIALOG = 'REPORT_LIST_OPEN_GROUP_DIALOG';
export const SELECTED_GROUP_FROM_DIALOG = 'SELECTED_GROUP_FROM_DIALOG';
export const SCORING_REPORT_SEARCH = 'SCORING_REPORT_SEARCH';
export const UPDATE_SCORING_REPORT_SEARCH_CONDITION = 'UPDATE_SCORING_REPORT_SEARCH_CONDITION';
export const EDIT_BY_CORRECTOR = 'EDIT_BY_CORRECTOR';
export const SAVE_MODAL_REPORT_DATA = 'SAVE_MODAL_REPORT_DATA';
export const RESET_REPORT_LIST = 'RESET_REPORT_LIST';
export const RESET_DETAIL_DRILL = 'RESET_DETAIL_DRILL';
export const DISABLE_GET_REPORT_BUTTON = 'DISABLE_GET_REPORT_BUTTON';
export const REPORT_OPERATION_TYPE = {
  APPROVAL: 0,
  REMAND: 1,
  COLLECT: 2,
  FINISH: 6,
  SAVE: 7,
};

// #7404 START
export const RECEIVED_DRILL_TOP_INFO = 'RECEIVED_DRILL_TOP_INFO';
export const RECEIVED_EACH_QUESTION = 'RECEIVED_EACH_QUESTION';
// #7404 END
